export const WHITE = '#ddd'
export const BLUE = '#0074D9'
export const GREEN = '#2ECC40'
export const RED = '#FF4136'
export const GREY = '#aaa'
